export default "__VITE_ASSET__CLbsHgaA__"